import styled from "styled-components";
import { useState, useEffect } from "react";
import { gql, useQuery, useMutation } from "@apollo/client";
import { captureException } from "@sentry/react";
import { useDispatch } from "react-redux";

import ClaimReward from "./ClaimReward";

// Actions
import { updateTelegramRewardList } from "store/actions";

const ModalWrap = styled.div`
  width: 100%;
  margin: 0;
  padding: 0;
`;

export default () => {
  const dispatch = useDispatch();

  const [code, setCode] = useState("");
  const [loadingClaimReward, setLoadingClaimReward] = useState(false);
  const [warning, setWarning] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [rewardNotFoundBox, setRewardNotFoundBox] = useState(false);
  const [rewardsAlreadyPaidBox, setRewardsAlreadyPaidBox] = useState(false);
  const [smallStreakBox, setSmallStreakBox] = useState(false);
  const [streakRequired, setStreakRequired] = useState(null);
  const [resultBox, setResultBox] = useState(false);
  const [resultOrder, setResultOrder] = useState(null);
  const [resultReward, setResultReward] = useState(null);

  const onCodeInputChange = (e) => {
    setCode(e.target.value);
  };

  const CLAIM_TELEGRAM_REWARD = gql`
    mutation CreateVerificationCode($code: String!) {
      claimTelegramReward(code: $code) {
        resultCode
        requiredStreak
        resultOrder
        resultReward
      }
    }
  `;

  const [claimTelegramReward] = useMutation(CLAIM_TELEGRAM_REWARD);

  const claimReward = async () => {
    try {
      if (loadingClaimReward) return;

      //validate code input
      if (code.length !== 4) {
        setWarning(true);
        setErrorMessage("The code must be 4 characters long.");
        return;
      }

      setWarning(false);
      setErrorMessage(null);
      setLoadingClaimReward(true);

      const result = await claimTelegramReward({
        variables: {
          code,
        },
      });

      const { resultCode } = result.data.claimTelegramReward;

      if (resultCode === 5) {
        // No reward found (incorrect code)
        setLoadingClaimReward(false);
        setRewardNotFoundBox(true);
        dispatch(updateTelegramRewardList(new Date().toISOString()));
        return;
      }

      if (resultCode === 6) {
        // Reward already closed
        setLoadingClaimReward(false);
        setRewardsAlreadyPaidBox(true);
        dispatch(updateTelegramRewardList(new Date().toISOString()));
        return;
      }

      if (resultCode === 9) {
        // Small activity streak
        setLoadingClaimReward(false);
        setStreakRequired(result.data.claimTelegramReward.requiredStreak);
        setSmallStreakBox(true);
        dispatch(updateTelegramRewardList(new Date().toISOString()));
        return;
      }

      if (resultCode !== 0) {
        setLoadingClaimReward(false);
        setErrorMessage(
          "An error occurred while submitting the request. Please try again or contact support."
        );
        return;
      }

      setLoadingClaimReward(false);
      setResultBox(true);
      setResultOrder(result.data.claimTelegramReward.resultOrder);
      setResultReward(result.data.claimTelegramReward.resultReward);
      dispatch(updateTelegramRewardList(new Date().toISOString()));
    } catch (error) {
      console.log("claimReward error", error);
      captureException(error);
      setLoadingClaimReward(false);
      setErrorMessage(
        "An error occurred while submitting the request. Please try again or contact support."
      );
      return;
    }
  };

  const closeResultBox = () => {
    setRewardNotFoundBox(false);
    setRewardsAlreadyPaidBox(false);
    setSmallStreakBox(false);
    setResultBox(false);
    setCode("");
    setResultOrder(null);
    setResultReward(null);
  };

  return (
    <ClaimReward
      code={code}
      onCodeInputChange={onCodeInputChange}
      warning={warning}
      errorMessage={errorMessage}
      claimReward={claimReward}
      rewardNotFoundBox={rewardNotFoundBox}
      closeResultBox={closeResultBox}
      rewardsAlreadyPaidBox={rewardsAlreadyPaidBox}
      smallStreakBox={smallStreakBox}
      streakRequired={streakRequired}
      loadingClaimReward={loadingClaimReward}
      resultBox={resultBox}
      resultOrder={resultOrder}
      resultReward={resultReward}
    />
  );
};
